module.exports = __webpack_public_path__ + "img/92103.a25b1ed1.svg";